<template>

	<div class="admin-dashboard-plugins-EmployeeScoreGrid">

		<dashboard-plugin
			name="Acceptatiegraad per gebruiker"
			instruction="Bekijk per gebruiker de acceptatiegraad van de ontvangen meldingen."
			headerPaddingRight="25%"
			:loading="loading"
			:loadedFirstTime="loadedFirstTime"
			:hasData="hasData"
		>

			<grid
				ref="grid"
				style="margin-top: -72px"
				:columns="employeeScoreColumns"
				:rows="employeesWithScore"
			/>

		</dashboard-plugin>

	</div>

</template>

<script>

import DashboardPlugin from "./common/DashboardPlugin";
import Api from "../api";
import Grid from "./common/Grid";
import loader from "./mixins/loader";

export default {
	name: 'employee-score-grid',
	mixins: [loader],
	components: {
		DashboardPlugin,
		Grid
	},
	props: {

	},

	data: () => {
		return {

			// The columns that are set on the table/ grid with the employee scores
			employeeScoreColumns: [
				{
					property: 'name',
					title: 'Naam',
					direction: null,
					filterable: true,
				},
				{
					property: 'amountOfRejected',
					title: 'Geweigerd',
					direction: null,
					filterable: false,
				},
				{
					property: 'amountOfAccepted',
					title: 'Geaccepteerd',
					direction: null,
					filterable: false,
				},
				{
					property: 'amountOfIgnored',
					title: 'Niet gereageerd',
					direction: null,
					filterable: false,
				},
				{
					property: 'amountOfEntries',
					title: 'Totaal',
					direction: null,
					filterable: false,
				},
				{
					property: 'averageAcceptedDuration',
					title: 'Gemiddelde acceptatietijd',
					direction: null,
					filterable: false,
				},
				{
					property: 'score',
					title: 'Acceptatiegraad',
					direction: null,
					filterable: false,
				},
			],

			// The values for the above columns
			employeesWithScore: [],

			// Used to know if the grid is already patched to not handle a 'enter' press as a page reload
			formsIsPatched: false,
		}
	},

	methods: {
		updateHandler()
		{
			if(!this.formsIsPatched)
			{
				let forms = document.querySelectorAll("form.vue-ads-font-sans.vue-ads-flex-grow");

				if(forms.length > 0)
					this.patchForm(forms[0])
			}

			this.update();
		},

		async update()
		{
			this.incrementLoading()

			// Needed to set our
			let table = this?.$refs?.grid?.$refs?.table.$refs.table

			// Get the employees with their corresponding score. These are used to display in the grid
			this.employeesWithScore = await Api.getEmployeesWithScore()

			if(table) {
				this.$nextTick(() => {
					table.totalFilteredRowsChanged(table.filteredRows.length)
				})
			}


			this.decrementLoading()
		},

		// Don't reload the page when we press enter after typing something in the filter
		patchForm(formToPatch)
		{
			formToPatch.addEventListener('submit', (event) => {
				event.preventDefault()
				return false
			})
		}

	},

	computed: {

		hasData()
		{
			return this.employeesWithScore.length > 0;
		}
	}
}
</script>

<style lang="scss">

	.admin-dashboard-plugins-EmployeeScoreGrid .admin-dashboard-plugins-common-Grid th:not(:first-child) {
		width: 130px;
	}

</style>
